<template>
  <div>
      {{src}}
  </div>
</template>

<script>
export default {
  name: 'error_404',
  data () {
    return {
      src: 'error404'
    }
  }
}
</script>
